export default __webpack_public_path__ + "static/res-1-lg-a4dd283795286aa2006a4af79134d728.png";